import AuthenticationService from 'business/services/AuthenticationService';
import LicenseService from 'business/services/LicenseService';
import { useCallback } from 'react';
import Cookies from 'js-cookie';
import { clearUserDataAndLogout, delay, removeCookie } from 'utils/Global';
import { useRMDispatch } from 'redux/hooks';
import { removeAllBackgroundJobs } from 'redux/reducers/backgroundJobsReducer';
import { removeAllTasks } from 'redux/reducers/systemTaskReducer';

const API_REQ_WAIT_MS = 500;

const authService = new AuthenticationService();
const licenseService = new LicenseService();

const removeSelectedLicense = () => {
  removeCookie('selectedLicenseType', 'logout');
  removeCookie('selectedLicenseIndex', 'logout');
  removeCookie('regComputerName', 'logout');
};

const useLogoutUser = () => {
  const dispatch = useRMDispatch();

  const logoutUser = useCallback(async (postLoginRedirectTo?: string) => {
    if (Cookies.get('selectedLicenseType') === 'Seat') {
      if (!Cookies.get('regComputerName')) {
        removeSelectedLicense();
      } else {
        const isSeatRegistered = await licenseService.isSeatRegistered();
        if (!isSeatRegistered) {
          removeSelectedLicense();
        }
      }
    }

    const logout = authService.logoutUser();
    // HACK: makesure the api request has been sent
    await delay(API_REQ_WAIT_MS);

    dispatch(removeAllBackgroundJobs());
    dispatch(removeAllTasks());

    clearUserDataAndLogout(true, postLoginRedirectTo);

    try {
      await logout;
    } catch (error) {
      console.warn('Logout API failed or cookie missing:', error);
    }
  }, []);

  return logoutUser;
};

export default useLogoutUser;
